<template>
  <div class="page" :class="'page_' + lang">
    <VideoContainer :currentPage="currentPage"></VideoContainer>
    <div :id="page.home.$path" v-if="page.home" :class="{'active': isActive()}">
      <div class="section">
        <div class="section__top">
          <div class="section__text reduced-width">
            <PageTitle :isActive="isActive()" :isAnimated="isAnimated" :class="{'static': isAnimated}" :titleValue="page.home.title"></PageTitle>
            <Description :descrValue="page.home.text_description" :isActive="isActive()" :class="{'static': isAnimated}"/>
            <div class="home-extra" :class="{'animating': pageReady && isSubTitle() && subTitle}">
              <div class="home-extra__item">
                <div class="home-extra__item-title animated-title">
                  <PageTitleContent :isActive="isActive()" :isAnimated="isAnimated" :class="{'static': isAnimated}" :titleValue="page.home.text_extra_title_1"></PageTitleContent>
                </div>
                <div class="home-extra__item-text" v-html="page.home.text_extra_content_1"></div>
              </div>
              <div class="home-extra__item">
                <div class="home-extra__item-title animated-title">
                  <PageTitleContent :isActive="isActive()" :isAnimated="isAnimated" :class="{'static': isAnimated}" :titleValue="page.home.text_extra_title_2"></PageTitleContent>
                </div>
                <div class="home-extra__item-text" v-html="page.home.text_extra_content_2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <About></About>
    <Portfolio></Portfolio>
    <PortfolioContent></PortfolioContent>
    <Founders></Founders>
    <FoundersContent></FoundersContent>
    <Team></Team>
    <TeamContent></TeamContent>
    <News></News>
    <PrivateEquity></PrivateEquity>
    <PrivateEquityContent></PrivateEquityContent>
    <Contacts></Contacts>
    <FooterComponent v-if="page.home" :copyright="page.home.text_footer_copy" :madeIn="page.home.text_footer_made_in"></FooterComponent>
    <transition name="fade">
      <div v-show="popupOpened" class="fader" @click="closePopup()"></div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageTitle from '@/components/PageTitle';
import PageTitleContent from '@/components/PageTitleContent';
import Description from '@/components/Description';
import VideoContainer from '@/components/VideoContainer';
import FooterComponent from '@/components/FooterComponent';
import About from '@/pages/About';
import Team from '@/pages/Team';
import TeamContent from '@/pages/TeamContent';
import Founders from '@/pages/Founders';
import FoundersContent from '@/pages/FoundersContent';
import Portfolio from '@/pages/Portfolio';
import PortfolioContent from '@/pages/PortfolioContent';
import News from '@/pages/News';
import PrivateEquity from '@/pages/PrivateEquity';
import PrivateEquityContent from '@/pages/PrivateEquityContent';
import Contacts from '@/pages/Contacts';

export default {
  name: 'home',
  data() {
    return {
      subTitle: false,
      isAnimated: false,
    };
  },
  computed: mapGetters({
    lang: 'lang',
    page: 'page',
    pageReady: 'pageReady',
    currentPage: 'currentPage',
    popupOpened: 'popupOpened',
    pageIsAutoScrolling: 'pageIsAutoScrolling',
  }),
  components: {
    PageTitle,
    PageTitleContent,
    Description,
    VideoContainer,
    FooterComponent,
    About,
    Team,
    TeamContent,
    Founders,
    FoundersContent,
    Portfolio,
    PortfolioContent,
    News,
    PrivateEquity,
    PrivateEquityContent,
    Contacts,
  },
  watch: {
    lang() {
      this.getData();
    },
  },
  methods: {
    isActive() {
      const checkActive = this.currentPage === this.page.home.$path && !this.pageIsAutoScrolling;
      const animationTime = (this.page.home.title.length * 70) + 5000;
      setTimeout(() => {
        if (checkActive) {
          this.isAnimated = true;
        }
      }, animationTime);
      return checkActive;
    },
    isSubTitle() {
      return setTimeout(() => {
        this.subTitle = true;
        return true;
      }, 1000);
    },
    closePopup() {
      this.$store.commit('SET_CURRENT_PERSON', '');
      this.$store.commit('SET_CURRENT_PROJECT', '');
      this.$store.commit('SET_CURRENT_ARTICLE', '');
      this.$store.commit('SET_POPUP_STATE', false);
    },
    getData() {
      this.$store.dispatch('fetchPage', { lang: this.lang, $http: this.$http });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#home {
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 1;
  position: fixed;
  pointer-events: none;

  .section__title {
    white-space: nowrap;
  } 

  &.active {
    pointer-events: auto;
  }

  .section {
    position: relative;
  }
}

.fade {
  &-enter,
  &-leave {
    &-active {
      transition: opacity 0.5s ease;
    }
  }

  &-enter,
  &-leave-to {
    opacity: 0;
  }
}

.home-extra {
  margin-top: 30px;
  text-align: right;
  right: 10%;

  &__item {
    display: inline-block;
    vertical-align: top;
    max-width: 350px;
    margin-right: 70px;
    text-align: left;

    &:last-child {
      margin-right: 0;
    }

    &-title {
      margin-bottom: -10px;
      font-size: 100px;
      line-height: 100%;
      white-space: nowrap;
      font-family: 'DietDidotTitleBold';
    }

    &-text {
      position: relative;
      left: -20px;
      opacity: 0;
      transition: all 0.5s cubic-bezier(0.500, 0.000, 0.100, 1.000) 0.7s;
      transform: translate3d(0, 0, 0);

      .animating & {
        opacity: 1;
        left: 0;
      }
    }
  }
}

@media (max-width: 990px) {
  .home-extra {
    &__item {
      &-title {
        font-size: 80px;
      }
    }
  }
}

@media (max-width: 850px){
  #home {
    .section {
      &__top {
        padding-top: 90px;
      }
      
      &__title {
        white-space: normal;
      } 
    }
  }

  .home-extra {
    text-align: left;
    padding: 0;

    &__item {
      display: inline-block;
      vertical-align: top;
      width: 46%;
      margin-right: 6%;

      &-title {
        margin-bottom: 10px;
        font-size: 52px;
      }

      &-text {
        line-height: 160%;
      }
    }
  }
}

@media (max-width: 460px){
  .home-extra {
    &__item {
      &-title {
        .page_ru & {
          font-size: 38px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue?7d6d5a28